import { get, has } from 'lodash'
import { OutputSelector } from 'reselect'
import { Currency, User, ReleaseNote } from 'Types/index'
import { createDeepEqualSelector } from 'Redux/selectors/index'

export interface authState {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  auth: any
  user: User
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getState = (state: any) => state.auth

export const getIsAuth = createDeepEqualSelector(getState, auth =>
  has(auth, 'credentials.AccessToken')
)
export const getIsArtist = createDeepEqualSelector(
  getState,
  ({ isArtist }) => isArtist
)
export const getUserRole = createDeepEqualSelector(getState, ({ role }) => role)
export const getAuthType = createDeepEqualSelector(
  getState,
  ({ authType }) => authType
)
export const getUserPassword = createDeepEqualSelector(
  getState,
  ({ isPassword }) => isPassword
)
export const getIsEmailBounced = createDeepEqualSelector(
  getState,
  ({ isEmailBounced }) => isEmailBounced
)
export const getCredentials = createDeepEqualSelector(
  getState,
  auth => auth.credentials
)

export const getVerified = createDeepEqualSelector(
  getState,
  auth => auth.verified
)

export const getPaypalEmail = createDeepEqualSelector(
  getState,
  auth => auth.user.paypal_email
)
export const getIdToken = createDeepEqualSelector(
  getState,
  auth => auth.credentials.IdToken
)
export const getIsBlocked = createDeepEqualSelector(
  getState,
  ({ isBlocked }) => isBlocked
)

export const getAccessToken = createDeepEqualSelector(getState, auth =>
  get(auth, 'credentials.AccessToken', null)
)

export const getRefreshToken = createDeepEqualSelector(getState, auth =>
  get(auth, 'credentials.RefreshToken', null)
)

export const getAuthError = createDeepEqualSelector(
  getState,
  auth => auth.errors
)

export const getCode = createDeepEqualSelector(getState, auth => auth.code)

export const getFindHelpData = createDeepEqualSelector(
  getState,
  findHelp => findHelp
)

export const getUser: OutputSelector<
  [],
  User,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, auth => auth.user)

export const getCurrency: OutputSelector<
  [],
  Currency,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ currency }) => currency)

export const getCountryName = createDeepEqualSelector(
  getState,
  ({ user }) => user.country
)
export const getCreatorTiktokProfileData = createDeepEqualSelector(
  getState,
  ({ tiktokProfile }) => tiktokProfile
)

export const getCuratorSpotifyId: OutputSelector<
  unknown,
  string,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ user }) => user.spotifyId)

export const getUserSelector: OutputSelector<
  unknown,
  User,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ user }) => user)

export const getIsFirstCampaign: OutputSelector<
  unknown,
  boolean,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ user }) => user?.is_first_campaign)

export const getUserId: OutputSelector<
  unknown,
  string,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ user }) =>
  user?.id ? user.id : user.curatorId
)
export const getAreTermsAccepted: OutputSelector<
  unknown,
  boolean,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ user }) => user.are_terms_accepted)

export const getTermsPosition: OutputSelector<
  unknown,
  number,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ user }) => user.terms_position)

export const getIsNewTerm: OutputSelector<
  unknown,
  boolean,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ user }) => user.is_new_term)

export const getReleaseNotes: OutputSelector<
  unknown,
  [ReleaseNote] | undefined,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ user }) => user?.release_notes)

export const getIsDeactivated: OutputSelector<
  unknown,
  boolean | undefined,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ user }) => user?.isDeactivated)

export const getArtistBalance: OutputSelector<
  unknown,
  number | undefined,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ user }) => user?.balance)

export const getIsNewFeed: OutputSelector<
  unknown,
  boolean | undefined,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ user }) => user?.is_new_feed)

export const getIsFeedBanner: OutputSelector<
  unknown,
  boolean | undefined,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ user }) => user?.is_feed_banner)
